import { Directive } from '@angular/core';
import { NG_VALIDATORS, FormControl } from '@angular/forms';
import * as moment from 'moment';

//conv dd/mm/yyyy to timestamp

export function pastDateValidator(control: FormControl) {
    let date = control.value;
    let day, month, year;
    if (date) {
        var dateMoment = moment(date, "DD-MM-YYYY");
        var yesterdayMoment = moment().subtract(1, 'days');
        var todayMoment = moment();

        if(dateMoment.isValid()){

            if(dateMoment.isAfter(todayMoment)){
                return {
                    notPastDate: true
                }
            }

            if(dateMoment.isAfter(yesterdayMoment)){
                return {
                    notPastDate : true
                }
            }

            // if(dateMoment.isBefore(todayMoment)){

            //     return {
            //         pastDate : true
            //     }
            // }

            // if(todayMoment.diff(dateMoment, 'years') < 18){

            //     return{
            //         minor : true
            //     }
            // }





        }
        
        if(!dateMoment.isValid()){

            return {
                invalidDate: true
            }

        }
    }


    return null;
}

@Directive({
    selector: '[pastDateValidator][ngModel]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useValue: pastDateValidator,
            multi: true
        }
    ]
})
export class PastDateValidator {
}